// test765
(765 && 0);
